import React from "react";
import "./SectionB.css";
import FaqGroup from "../QuestionDropDown/FaqGroup.jsx";
import guyDude from "../../assets/FAQ.svg";

const SectionB = () => {
  return (
    <>
      <div id="faq" className="faq-body">
        <div classname="faq-contains">
          <div className="faq-title-contains">
            <h1 style={{ fontSize: "2.25em", margin:"0" }}>FAQs</h1>
          </div>
          <div className="faq-img-contain non-selectable">
            <img
              src={guyDude}
              className="faq-img"
              alt="You have questions? Go ahead, ask them"
            />
          </div>
          <div className="faq-ask">
            <FaqGroup />
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionB;
